import { VirtualKeyboardLayout } from './virtual-keyboard.types'

/** Tecla de apagar um caractere (simple-keyboard). */
export const KEY_BKSP = '{bksp}'
/** Tecla de limpar o campo inteiro. */
export const KEY_CLEAR = '{clear}'
/** Alterna maiúsculas no layout alfanumérico. */
export const KEY_SHIFT = '{shift}'
/** Espaço. */
export const KEY_SPACE = '{space}'

/**
 * Layouts de teclas. O numérico segue o protótipo do chamado: 1-9 em três
 * linhas, e a última linha com limpar (C), 0 e apagar.
 *
 * O alfanumérico mantém a linha de números no topo (nome/e-mail/endereço
 * frequentemente têm dígitos) e traz ç e as vogais acentuadas: sem elas o
 * paciente não consegue escrever o próprio endereço em português ("João",
 * "América", "Conceição"). Fora isso, só as teclas necessárias — nada de
 * F1-F12, Tab, Ctrl.
 */
export const KEYBOARD_LAYOUTS: Record<
  VirtualKeyboardLayout,
  { default: string[]; shift?: string[] }
> = {
  numeric: {
    default: ['1 2 3', '4 5 6', '7 8 9', `${KEY_CLEAR} 0 ${KEY_BKSP}`],
  },
  alphanumeric: {
    default: [
      '1 2 3 4 5 6 7 8 9 0',
      'q w e r t y u i o p',
      'a s d f g h j k l ç',
      `${KEY_SHIFT} z x c v b n m ${KEY_BKSP}`,
      'á à â ã é ê í ó ô õ ú',
      `@ . - _ ${KEY_SPACE} ${KEY_CLEAR}`,
    ],
    shift: [
      '1 2 3 4 5 6 7 8 9 0',
      'Q W E R T Y U I O P',
      'A S D F G H J K L Ç',
      `${KEY_SHIFT} Z X C V B N M ${KEY_BKSP}`,
      'Á À Â Ã É Ê Í Ó Ô Õ Ú',
      `@ . - _ ${KEY_SPACE} ${KEY_CLEAR}`,
    ],
  },
}

/** Rótulos das teclas de controle — texto curto e legível no totem. */
export const KEYBOARD_DISPLAY: { [key: string]: string } = {
  [KEY_BKSP]: '⌫',
  [KEY_CLEAR]: 'C',
  [KEY_SHIFT]: '⇧',
  [KEY_SPACE]: 'espaço',
}
